import React from 'react';
import View from './View';
import { useUser } from "../../../../context";
var EvoluxBenefitsWidgetContainer = function (_a) {
    var showButton = _a.showButton;
    var account = useUser().account;
    return (React.createElement(View, { currentLevelName: account === null || account === void 0 ? void 0 : account.currentQuarterLoyalty.pricedWith.level, defaultRate: 520, msrp: 610, pricingModel: account === null || account === void 0 ? void 0 : account.pricingModel, levels: account === null || account === void 0 ? void 0 : account.currentQuarterLoyalty.levels, isLoading: false, showButton: showButton, annualCampaigns: [] }));
};
export default EvoluxBenefitsWidgetContainer;
